import store from '../store/index'
import { permission } from './permission'
import moment from 'moment'

const guestMiddleware = next => {
  if (store.state.auth.token && store.state.auth.token !== 'null') {
    return next({
      name: 'home'
    })
  } else {
    return next()
  }
}

const authMiddleware = (next, to) => {
  if (
    store.state.auth.token &&
    store.state.auth.token !== null &&
    store.state.auth.expiresIn &&
    store.state.auth.expiresIn > moment().unix()
  ) {
    if (to.meta.roles) {
      permission(next, to)
    } else {
      return next()
    }
  } else {
    return next({
      name: 'login'
    })
  }
}

const gceAuthMiddleware = (next, to) => {
  if (
    store.state.auth.gceToken &&
    store.state.auth.gceToken !== null &&
    store.state.auth.gceExpiresIn &&
    store.state.auth.gceExpiresIn > moment().unix()
  ) {
    if (to.meta.gceAuth) {
      permission(next, to)
    } else {
      return next()
    }
  } else {
    return next({
      // name: 'gcelogin'
    })
  }
}

const basicMiddleware = next => {
  return next()
}

export { guestMiddleware, authMiddleware, basicMiddleware, gceAuthMiddleware }
